import React from 'react';

const Divider: React.FC = () => <div className="change-email-modal--divider" />;

export default Divider;
